import React from "react";
import { Dropdown } from "react-bootstrap";
import { ArrowDownIcon } from "../../Icons/icons.component";
import { UNSET_THEME_LABEL } from "../../../constants/app-constant";

export function CategoryTag({
  label,
  defaultValue,
  onSelect,
  options = [],
  hideUnsetOption,
  isPrintAndOnline,
  forBulkUpdate,
  isDisabled,
}) {
  const onSelectItem = (item) => {
    onSelect(item);
  };

  const getLabel = () => {
    if (!isPrintAndOnline) {
      if (!defaultValue || defaultValue === UNSET_THEME_LABEL) return label;
    }
    return UNSET_THEME_LABEL;
  };

  const getOptionClass = () => {
    if (!(isPrintAndOnline && forBulkUpdate)) {
      if (!defaultValue || defaultValue === UNSET_THEME_LABEL) {
        return "disabled";
      }
    }
    return "";
  };
  const faceValue =
    !defaultValue || defaultValue === UNSET_THEME_LABEL ? label : defaultValue;

  return (
    <>
      {isDisabled ? (
        defaultValue && <span className="tagLabel">{defaultValue}</span>
      ) : (
        <Dropdown className="categoryDropdown" alignRight>
          <Dropdown.Toggle variant="default" disabled={isDisabled}>
            {faceValue}
            <ArrowDownIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onSelect={() => {
                onSelectItem(UNSET_THEME_LABEL);
              }}
              value={"-1"}
              className={getOptionClass()}
            >
              {getLabel()}
            </Dropdown.Item>
            {options &&
              options.map(({ id, category_name }) => {
                return (
                  <Dropdown.Item
                    onSelect={() => {
                      onSelectItem(category_name);
                    }}
                    key={id}
                    value={category_name}
                  >
                    {category_name}
                  </Dropdown.Item>
                );
              })}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
